// src/components/Navbar.jsx
import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
import "./Navbar.css";

const DEST_LINKS = [
  "Dubai","Antalya","Tenerife","Maldives","Majorca",
  "Lanzarote","Barcelona","Phuket","Bali","Rhodes",
  "Gran Canaria","Corfu","Cyprus","Hurghada","Benidorm",
];

const IC = {
  Menu: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <line x1="3" y1="6"  x2="21" y2="6"/>
      <line x1="3" y1="12" x2="21" y2="12"/>
      <line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  ),
  X: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18"/>
      <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  ChevD: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  ),
  Pin: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  ),
  Phone: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.91-1.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  ),
  WA: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.985-1.349A9.954 9.954 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z"/>
    </svg>
  ),
  Search: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  ),
  Right: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  ),
  // ── NEW: My Booking icon ──
  Booking: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
      <polyline points="10 9 9 9 8 9"/>
    </svg>
  ),
};

export default function Navbar() {
  const [menuOpen, setMenuOpen]   = useState(false);
  const [destOpen, setDestOpen]   = useState(false);
  const [scrolled, setScrolled]   = useState(false);
  const destRef = useRef(null);
  const loc = useLocation();

  useEffect(() => {
    const h = e => { if (destRef.current && !destRef.current.contains(e.target)) setDestOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 6);
    window.addEventListener("scroll", h, { passive:true });
    return () => window.removeEventListener("scroll", h);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const ci = new Date(Date.now() + 45*86400000).toISOString().split("T")[0];
  const co = new Date(Date.now() + 52*86400000).toISOString().split("T")[0];
  const isOn = p => loc.pathname === p;

  return (
    <>
      <header className={`nb-header${scrolled ? " nb-scrolled" : ""}`}>
        <div className="nb-inner">

          {/* ── Logo ── */}
          <Link to="/" className="nb-logo" onClick={() => setMenuOpen(false)}>
            <div className="nb-logo-ring">
              <img src={logo} alt="Broadway Holidays"/>
            </div>
            <div className="nb-logo-text">
              <span className="nb-logo-b">Broadway</span>
              <span className="nb-logo-h">Holidays</span>
            </div>
          </Link>

          {/* ── Desktop nav ── */}
          <nav className="nb-nav">
            <Link to="/"       className={`nb-link${isOn("/")?" nb-on":""}`}>Home</Link>
            <Link to="/hotels" className={`nb-link${isOn("/hotels")?" nb-on":""}`}>Hotels</Link>

            <Link
              to={`/hotels?city=&checkIn=${ci}&checkOut=${co}&guests=2&rooms=1&mode=package`}
              className="nb-link nb-link-deals"
            >
              <IC.Search/>
              All Deals
            </Link>

            {/* Destinations dropdown */}
            <div
              className="nb-dd"
              ref={destRef}
              onMouseEnter={() => setDestOpen(true)}
              onMouseLeave={() => setDestOpen(false)}
            >
              <button className={`nb-link nb-dd-btn${destOpen?" nb-on":""}`}>
                Destinations <IC.ChevD/>
              </button>
              {destOpen && (
                <div className="nb-dd-panel">
                  <div className="nb-dd-grid">
                    {DEST_LINKS.map(d => (
                      <Link
                        key={d}
                        to={`/hotels?city=${encodeURIComponent(d)}&checkIn=${ci}&checkOut=${co}&guests=2`}
                        className="nb-dd-item"
                        onClick={() => setDestOpen(false)}
                      >
                        <IC.Pin/>
                        {d}
                      </Link>
                    ))}
                  </div>
                  <div className="nb-dd-footer">
                    <Link
                      to={`/hotels?city=&checkIn=${ci}&checkOut=${co}&guests=2`}
                      className="nb-dd-all"
                      onClick={() => setDestOpen(false)}
                    >
                      View all destinations <IC.Right/>
                    </Link>
                  </div>
                </div>
              )}
            </div>

            <Link to="/contact"    className={`nb-link${isOn("/contact")?" nb-on":""}`}>Contact</Link>

            {/* ── My Booking link ── */}
            <Link
              to="/my-booking"
              className={`nb-link nb-link-mybooking${isOn("/my-booking")?" nb-on":""}`}
            >
              <IC.Booking/>
              My Booking
            </Link>
          </nav>

          {/* ── CTA ── */}
          <div className="nb-cta">
            <a href="https://wa.me/447487672075" target="_blank" rel="noreferrer" className="nb-btn-wa">
              <IC.WA/> WhatsApp
            </a>
            <a href="tel:02030190055" className="nb-btn-call">
              <IC.Phone/> 020 3019 0055
            </a>
          </div>

          {/* ── My Booking visible on mobile ── */}
          <Link
            to="/my-booking"
            className={`nb-mybooking-pill${isOn("/my-booking") ? " nb-mbp-active" : ""}`}
            onClick={() => setMenuOpen(false)}
          >
            <IC.Booking/>
            <span>My Booking</span>
          </Link>

          {/* ── Burger ── */}
          <button
            className="nb-burger"
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          >
            <IC.Menu/>
          </button>
        </div>
      </header>

      {/* ── MOBILE DRAWER ── */}
      {menuOpen && (
        <div className="nb-overlay" onClick={() => setMenuOpen(false)}>
          <div className="nb-drawer" onClick={e => e.stopPropagation()}>

            <div className="nb-dhead">
              <div className="nb-logo-ring nb-logo-ring-sm">
                <img src={logo} alt="Broadway Holidays"/>
              </div>
              <div className="nb-logo-text">
                <span className="nb-logo-b" style={{ fontSize:15 }}>Broadway</span>
                <span className="nb-logo-h" style={{ fontSize:11 }}>Holidays</span>
              </div>
              <button className="nb-close" onClick={() => setMenuOpen(false)} aria-label="Close">
                <IC.X/>
              </button>
            </div>

            <div className="nb-dbody">
              <div className="nb-msect-hdr">Menu</div>
              {[
                { to:"/",       label:"Home" },
                { to:"/hotels", label:"Hotels" },
                { to:`/hotels?city=&checkIn=${ci}&checkOut=${co}&guests=2&rooms=1`,
                  label:"All Deals", deals:true },
                { to:"/contact", label:"Contact" },
              ].map(item => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`nb-mlink${item.deals?" nb-mlink-deals":""}`}
                  onClick={() => setMenuOpen(false)}
                >
                  {item.deals && <IC.Search/>}
                  {item.label}
                  <IC.Right/>
                </Link>
              ))}

              {/* ── My Booking in mobile drawer ── */}
              <Link
                to="/my-booking"
                className="nb-mlink nb-mlink-mybooking"
                onClick={() => setMenuOpen(false)}
              >
                <IC.Booking/>
                My Booking
                <IC.Right/>
              </Link>

              <div className="nb-msect-hdr" style={{ marginTop:8 }}>
                <IC.Pin/> Popular Destinations
              </div>
              <div className="nb-mdests">
                {DEST_LINKS.map(d => (
                  <Link
                    key={d}
                    to={`/hotels?city=${encodeURIComponent(d)}&checkIn=${ci}&checkOut=${co}&guests=2`}
                    className="nb-mdest"
                    onClick={() => setMenuOpen(false)}
                  >
                    {d}
                  </Link>
                ))}
              </div>
            </div>

            <div className="nb-dfoot">
              <a href="tel:02030190055" className="nb-mfoot-call" onClick={() => setMenuOpen(false)}>
                <IC.Phone/> 020 3019 0055
              </a>
              <a href="https://wa.me/447487672075" target="_blank" rel="noreferrer"
                className="nb-mfoot-wa" onClick={() => setMenuOpen(false)}>
                <IC.WA/> WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}